"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RubyTargetLanguage = exports.rubyOptions = void 0;
const RendererOptions_1 = require("../../RendererOptions");
const TargetLanguage_1 = require("../../TargetLanguage");
const RubyRenderer_1 = require("./RubyRenderer");
const utils_1 = require("./utils");
exports.rubyOptions = {
    justTypes: new RendererOptions_1.BooleanOption("just-types", "Plain types only", false),
    strictness: new RendererOptions_1.EnumOption("strictness", "Type strictness", [
        ["strict", utils_1.Strictness.Strict],
        ["coercible", utils_1.Strictness.Coercible],
        ["none", utils_1.Strictness.None]
    ]),
    namespace: new RendererOptions_1.StringOption("namespace", "Specify a wrapping Namespace", "NAME", "", "secondary")
};
class RubyTargetLanguage extends TargetLanguage_1.TargetLanguage {
    constructor() {
        super("Ruby", ["ruby"], "rb");
    }
    getOptions() {
        return [exports.rubyOptions.justTypes, exports.rubyOptions.strictness, exports.rubyOptions.namespace];
    }
    get supportsOptionalClassProperties() {
        return true;
    }
    get defaultIndentation() {
        return "  ";
    }
    makeRenderer(renderContext, untypedOptionValues) {
        return new RubyRenderer_1.RubyRenderer(this, renderContext, (0, RendererOptions_1.getOptionValues)(exports.rubyOptions, untypedOptionValues));
    }
}
exports.RubyTargetLanguage = RubyTargetLanguage;
